import { runDemo } from "../shared/demoRunner";
import { createLookAtScene } from "./scene";

runDemo({ createScene: createLookAtScene });
